import { useTranslation } from "react-i18next";
import AnomalyThresholdPanel from "./components/AnomalyThresholdPanel";
import AnomalyBehaviorList from "./components/AnomalyBehaviorList";
import AdminLayout from "@/components/layout/AdminLayout";
import AdminPageTitle from "@/components/admin/AdminPageTitle";

export default function SecurityMonitorPage() {
  const { t } = useTranslation();

  return (
    <AdminLayout>
      {/* Header */}
      <div className="flex items-start justify-between mb-6">
        <div>
          <AdminPageTitle title="Security Records" tooltip={t("securityMonitor.subtitle")} />
        </div>
        <span className="text-xs text-gray-400">{t("securityMonitor.realTime")}</span>
      </div>

      {/* Anomaly Behavior Detection Section */}
      <div>
        <AnomalyThresholdPanel />
        <div className="mt-5">
          <AnomalyBehaviorList />
        </div>
      </div>
    </AdminLayout>
  );
}
